import EditTemplate from "../_templates/EditTemplate";
import { playerSchema } from "../../../schemas/player.schema";
import { getPlayer, updatePlayer } from "../../../api/coredata.api";

export default function EditPlayer() {
  return (
    <EditTemplate
      title="Edit Player"
      schema={playerSchema}
      fetchFn={getPlayer}
      updateFn={updatePlayer}
      redirectPath="/cricket/players"
    />
  );
}
